<template>
  <div class="toast" v-if="visible" >
    <div class="mask" @touchmove.prevent.stop></div>
    <div :class="['toast_info',type==='success'?'success':'',type === 'error'?'error':'',type === 'loading'?'loading':'',type === 'info'?'info':'']">
      <div class="loading-icon" v-show="type === 'loading'">
        <img src="https://s.kcimg.cn/topic/images/38-carsisterinlaw/loading.png">
      </div>
      <i class="icon icon-success" v-show="type === 'success'"></i>
      <i class="icon icon-error" v-show="type === 'error'"></i>
      <p class="text-content" v-if="message" v-html="message"></p>
    </div>
  </div>
</template>
<script>
// const typeMap = {
//   success: 'success',
//   info: 'info',
//   warning: 'warning',
//   error: 'error'
// }
export default {
  props: {
    // visible: {
    //   default: false
    // },
    // text: {
    //   default: ''
    // },
    // infoShow: {
    //   default: true
    // },
    // duration: {
    //   default: 2000
    // },
    // type: {
    //   default: 'info'
    // },

  },
  data () {
    return {
      visible: false,
      message: '',
      duration: 3000,
      type: 'info',
      timer: null,
      closed: false,
      onClose: null
    }
  },
  watch: {
    closed (newVal) {
      if (newVal) {
        this.visible = false
      }
    }
  },
  mounted () {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.close()
        }
      }, this.duration)
    }
  },
  methods: {
    close () {
      this.closed = true
      if (typeof this.onClose === 'function') {
        this.onClose(this)
      }
    }
  }
}
</script>
<style scoped lang="less">
  .toast{
    z-index: 3000;
  }
  .mask{
    position: fixed;
    z-index: 3000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: transparent;
  }
  .toast_info{
    position: fixed;
    z-index: 4000;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #ffffff;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #17181a;
    line-height: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 400px;
    width: auto;
    height: auto;
    padding: 8px 16px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
  }
  .toast_info.loading{
    width: 120px;
    height: 120px;
    background: rgba(0,0,0,0.60);
    border-radius: 4px;
  }
  .toast_info.info{
    max-width: 400px;
    width: auto;
    height: auto;
    padding: 8px;
    background: rgba(0,0,0,0.60);
    border-radius: 4px;
  }
  .toast_info i{
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    background: url("../../assets/success.png");
    background-size:40px 40px;
  }
  .toast_info.error i{
    background: url(https://s.kcimg.cn/topic/images/superman-festival/nav-icon.png) no-repeat;
    background-size: 200px 68px;
    background-position: -160px 0;
  }
  .toast_info.success{
    width: 120px;
    height: 110px;
    padding-top:20px;
    padding-bottom: 18px;
    border-radius: 4px;
    .icon-success{
      margin-bottom: 8px;
    }
  }
  .toast p{
    color: #ffffff;
    font-size: 14px;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    width: 100%;
    word-break: break-all;
    margin: 0;
  }
  .toast_info.loading p,.toast_info.info p{
    font-size: 16px;
    color: #FFFFFF;
  }
  .loading-icon img{
    width: 32px;
    height: 32px;
    background: transparent;
    animation: spin 1s linear infinite;
  }
  @keyframes spin{
    from {
      transform:rotate(0);
    }
    to {
      transform:rotate(-360deg);
    }
  }
</style>
